import React from 'react'
import SplitValues from './SplitValues'

export default function PipedValues (props) {
  return (
    <SplitValues splitter={'|'} {...props}/>
  )
}
